import React from "react";
import { useNavigate } from "react-router";
import { useRecommendedPathForUser } from "src/ui/navigation/dashboardRouting/useRecommendedPathForUser";

export const DrawerLogoLink = (props: React.PropsWithChildren<object>) => {
    const navigate = useNavigate();
    const { path: recommendedPath, isLoading } = useRecommendedPathForUser();

    return (
        <a
            style={{ display: "inline-flex", alignItems: "center" }}
            href={isLoading ? "#" : recommendedPath}
            onClick={(e) => {
                e.preventDefault();
                if (isLoading) {
                    return;
                }
                void navigate(recommendedPath);
            }}
        >
            {props.children}
        </a>
    );
};
